import AvatarM from "@common/components/avatar/AvatarM"
import { IconImageM } from "@common/components/icons/IconsM"
import {
    SkillSetTitleFull,
    XPCount,
} from "@common/components/statistics/Counters"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { authService } from "@data/services/authService"
import { hasRole } from "@data/utility/ability"
import { AbilityContext } from "@data/utility/Can"
import { StatusBar } from "@common/systemBars/StatusBar"
import React, { useContext, useRef } from "react"
import {
    FlatList,
    Platform,
    Pressable,
    TouchableOpacity,
    View,
} from "react-native"
import { ActivityIndicator } from "react-native-paper"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { connect } from "react-redux"
import LiveAvatarM from "../../tutor/students/LiveAvatarM"

const ITEM_HEIGHT = 60

export function RankingListItem({
    user,
    isHighlighted,
    isOpacityLowered = false,
    rank,
    height = 60,
    isLiveMode = false,
    backofficeMode = false,
    onDelete = null,
    isLoading = false,
    withEmail = false,
    temporarilyAdded = false,
    temporarilyRemoved = false,
    attendanceFlagString = "",
    attendanceFlagColor = theme.colors.warning,
    onCancelAbsence = () => {},
    // Live session objective props
    userObjectives = [],
    attachedObjectiveId = null,
    onObjectiveClick = null,
    schoolSubjects = [],
    isObjectiveUpdateLoading = false,
    disableObjectives = false,
    onPress = null,
    isAdhoc = false,
    isReservation = false,
}) {
    const dimensions = useContext(DimensionsContext)
    const isTutor =
        hasRole(user, "tutor") ||
        user?.is_tutor ||
        (!rank && !user?.class && !user?.profile?.class)
    const ability = useContext(AbilityContext)

    const Container = onPress ? Pressable : View

    return (
        <Container
            onPress={onPress}
            style={{
                width:
                    Platform.OS !== "web"
                        ? dimensions?.width
                        : dimensions?.width - 120,
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                height: height,
                paddingVertical: 10,
                paddingHorizontal: 10,
                backgroundColor: isHighlighted
                    ? theme.colors.primaryLighter
                    : null,
                opacity: isOpacityLowered ? 0.5 : 1,
            }}
        >
            <View
                style={{
                    flexDirection: "row",
                    alignItems: "center",
                }}
            >
                {!!rank && (
                    <TextM
                        fontWeight="ExtraBold"
                        style={{ width: 30 }}
                        fontSize={rank > 99 ? 11 : 16}
                        wrap
                        color={theme.colors.primary}
                    >
                        {rank}
                    </TextM>
                )}
                {isLiveMode ? (
                    <LiveAvatarM user={user} />
                ) : (
                    <AvatarM
                        user={user}
                        style={{
                            marginRight: 2,
                        }}
                        size={50}
                    />
                )}
                <View
                    style={{
                        minWidth: 120,
                        marginLeft: 10,
                        maxWidth: backofficeMode ? null : 145,
                    }}
                >
                    <View
                        style={{
                            flexDirection: withEmail ? "row" : "column",
                            alignItems: withEmail ? "center" : null,
                        }}
                    >
                        <TextM
                            fontWeight="Bold"
                            style={{
                                marginRight: 10,
                                textDecoration: temporarilyRemoved
                                    ? "line-through"
                                    : null,
                            }}
                            fontSize={16}
                            color={
                                isTutor
                                    ? theme.colors.primary
                                    : theme.colors.grey
                            }
                        >
                            {backofficeMode && !!user?.firstname
                                ? user?.firstname + " " + user?.lastname
                                : user?.display_name}
                        </TextM>
                        <TextM
                            fontWeight="Medium"
                            style={{}}
                            color={isTutor ? theme.colors.primary : null}
                            fontSize={12}
                        >
                            {!isTutor
                                ? ability?.can("read", "my_students") ||
                                  ability?.can("read", "backOffice")
                                    ? user?.profile?.class
                                    : ""
                                : "Masteur"}
                        </TextM>
                        {isReservation && isAdhoc && (
                            <View
                                style={{
                                    backgroundColor: theme.colors.warning,
                                    borderRadius: 8,
                                    paddingHorizontal: 4,
                                    paddingVertical: 1,
                                    marginLeft: 5,
                                }}
                            >
                                <TextM
                                    fontSize={10}
                                    color={theme.colors.white}
                                    fontWeight="Bold"
                                >
                                    Pré-réservation
                                </TextM>
                            </View>
                        )}
                        {isReservation && !isAdhoc && (
                            <View
                                style={{
                                    backgroundColor: theme.colors.info,
                                    borderRadius: 8,
                                    paddingHorizontal: 4,
                                    paddingVertical: 1,
                                    marginLeft: 5,
                                }}
                            >
                                <TextM
                                    fontSize={10}
                                    color={theme.colors.white}
                                    fontWeight="Bold"
                                >
                                    Réservation
                                </TextM>
                            </View>
                        )}
                        {!!attendanceFlagString && (
                            <TouchableOpacity
                                onPress={onCancelAbsence}
                                style={{
                                    flexDirection: "row",
                                    alignItems: "center",
                                    gap: 5,
                                }}
                            >
                                <FontAwesome5
                                    name={"user"}
                                    size={10}
                                    color={attendanceFlagColor}
                                />
                                <TextM
                                    fontSize={10}
                                    color={attendanceFlagColor}
                                >
                                    {attendanceFlagString}
                                </TextM>
                            </TouchableOpacity>
                        )}
                    </View>
                    {withEmail && (
                        <TextM fontWeight="Light" fontSize={10}>
                            {user?.email}
                        </TextM>
                    )}
                    {/* Display objectives for students in backoffice mode */}
                    {backofficeMode &&
                        !isTutor &&
                        userObjectives.length > 0 && (
                            <View
                                style={{
                                    flexDirection: "row",
                                    flexWrap: "wrap",
                                    marginTop: 4,
                                }}
                            >
                                {userObjectives.map((objective) => {
                                    const isAttached =
                                        objective.id === attachedObjectiveId
                                    const isPending =
                                        objective.status === "pending"
                                    const isOngoing =
                                        objective.status === "ongoing"
                                    const subjectIds =
                                        objective.subject_ids || []
                                    const objectiveSubjects = subjectIds
                                        .map((id) =>
                                            schoolSubjects.find(
                                                (s) => s.id === id
                                            )
                                        )
                                        .filter(Boolean)

                                    return (
                                        <TouchableOpacity
                                            key={objective.id}
                                            disabled={
                                                isObjectiveUpdateLoading ||
                                                isAttached ||
                                                !isOngoing ||
                                                disableObjectives
                                            }
                                            onPress={() => {
                                                if (
                                                    !isOngoing ||
                                                    disableObjectives
                                                )
                                                    return // Disable non-ongoing objectives or when disabled
                                                onObjectiveClick &&
                                                    onObjectiveClick(objective)
                                            }}
                                            style={{
                                                backgroundColor: isAttached
                                                    ? theme.colors
                                                          .primaryLighter
                                                    : theme.colors.lighter,
                                                borderRadius: 8,
                                                paddingHorizontal: 6,
                                                paddingVertical: 2,
                                                marginRight: 4,
                                                marginBottom: 2,
                                                flexDirection: "row",
                                                alignItems: "center",
                                                opacity:
                                                    !isOngoing ||
                                                    disableObjectives
                                                        ? 0.3
                                                        : isAttached
                                                        ? 1
                                                        : 0.5,
                                                borderWidth: 1,
                                                borderColor: isAttached
                                                    ? theme.colors.primary
                                                    : isOngoing
                                                    ? theme.colors.lightMore
                                                    : "transparent",
                                                borderStyle: isAttached
                                                    ? "solid"
                                                    : isOngoing
                                                    ? "dashed"
                                                    : "solid",
                                            }}
                                        >
                                            {objectiveSubjects.length > 0 && (
                                                <View
                                                    style={{
                                                        flexDirection: "row",
                                                        marginRight: 4,
                                                    }}
                                                >
                                                    {objectiveSubjects
                                                        .slice(0, 2)
                                                        .map((subject, idx) => (
                                                            <IconImageM
                                                                uri={
                                                                    subject.icon
                                                                }
                                                                width={12}
                                                                style={{
                                                                    marginLeft:
                                                                        idx > 0
                                                                            ? 2
                                                                            : 0,
                                                                }}
                                                                key={subject.id}
                                                            />
                                                        ))}
                                                    {objectiveSubjects.length >
                                                        2 && (
                                                        <TextM
                                                            fontSize={8}
                                                            color={
                                                                theme.colors
                                                                    .grey
                                                            }
                                                            style={{
                                                                marginLeft: 2,
                                                            }}
                                                        >
                                                            +
                                                            {objectiveSubjects.length -
                                                                2}
                                                        </TextM>
                                                    )}
                                                </View>
                                            )}
                                            <TextM
                                                fontSize={9}
                                                color={
                                                    !isOngoing ||
                                                    disableObjectives
                                                        ? theme.colors.light
                                                        : isAttached
                                                        ? theme.colors.primary
                                                        : theme.colors.grey
                                                }
                                                fontWeight={
                                                    isAttached
                                                        ? "Bold"
                                                        : "Medium"
                                                }
                                            >
                                                {objective.type === "homework"
                                                    ? "Devoirs"
                                                    : objectiveSubjects
                                                          ?.map((s) => s.name)
                                                          .join(", ")}
                                                {!isOngoing &&
                                                    !isPending &&
                                                    " (fermé)"}
                                                {disableObjectives &&
                                                    " (temporaire)"}
                                            </TextM>
                                        </TouchableOpacity>
                                    )
                                })}
                                {isObjectiveUpdateLoading && (
                                    <View>
                                        <ActivityIndicator
                                            size={14}
                                            color={theme.colors.primary}
                                            style={{ marginLeft: 4 }}
                                        />
                                    </View>
                                )}
                            </View>
                        )}
                </View>
                {(temporarilyAdded || temporarilyRemoved) && (
                    <FontAwesome5
                        name={"clock"}
                        size={20}
                        color={theme.colors.primary}
                    />
                )}
            </View>
            <View
                style={{
                    minWidth: 110,
                    alignItems: "flex-end",
                    justifyContent: "center",
                    position: "relative",
                }}
            >
                {/* Floating activity indicator for objective updates */}
                {backofficeMode && !!onDelete ? (
                    isLoading ? (
                        <ActivityIndicator color={theme.colors.primary} />
                    ) : !temporarilyAdded && !temporarilyRemoved ? (
                        <Pressable onPress={onDelete}>
                            <FontAwesome5
                                name={"trash"}
                                size={20}
                                color={theme.colors.light}
                            />
                        </Pressable>
                    ) : null
                ) : !isTutor ? (
                    <>
                        <SkillSetTitleFull
                            title={user?.student_title}
                            skillSetId={user?.title_skill_set_id}
                            icon={user?.student_title_icon}
                            small
                            right
                        />
                        <XPCount
                            count={user?.xp}
                            small
                            right
                            style={{ marginRight: 3 }}
                        />
                    </>
                ) : null}
            </View>
        </Container>
    )
}

const RankingScreen = (props) => {
    const { rankingData, userRank, user } = props

    const highlightIndex = userRank <= rankingData?.length ? userRank - 1 : -1

    const flatListRef = useRef()
    const dimensions = useContext(DimensionsContext)

    return (
        <View
            style={{
                flex: 1,
                alignItems: "center",
                justifyContent: "flex-start",
                width: dimensions?.width,
                alignSelf: "center",
            }}
        >
            <FlatList
                data={rankingData}
                ref={flatListRef}
                getItemLayout={(data, index) => ({
                    length: ITEM_HEIGHT,
                    offset: ITEM_HEIGHT * index,
                    index,
                })}
                showsHorizontalScrollIndicator={Platform.OS === "web" && false}
                initialScrollIndex={
                    highlightIndex >= 0
                        ? highlightIndex
                        : rankingData.length - 1
                }
                refreshing={!!props.getUserRequest}
                onRefresh={() =>
                    props.apiRequest(
                        authService.getUser,
                        {},
                        {},
                        { refresh_rankings: true }
                    )
                }
                ListFooterComponent={() =>
                    highlightIndex < 0 && (
                        <View
                            style={{
                                width: dimensions?.width,
                            }}
                        >
                            {userRank - 1 > rankingData?.length && (
                                <View
                                    style={{
                                        width: dimensions?.width,
                                        alignItems: "center",
                                        paddingVertical: 6,
                                    }}
                                >
                                    <FontAwesome5
                                        name="ellipsis-h"
                                        size={30}
                                        color={theme.colors.light}
                                    />
                                </View>
                            )}
                            <RankingListItem
                                user={user}
                                isHighlighted={true}
                                height={ITEM_HEIGHT}
                                rank={userRank}
                            />
                        </View>
                    )
                }
                renderItem={(item) => {
                    return (
                        <RankingListItem
                            user={item.item}
                            isHighlighted={item.index === highlightIndex}
                            height={ITEM_HEIGHT}
                            rank={item.index + 1}
                        />
                    )
                }}
            />

            <StatusBar
                style="dark"
                backgroundColor={theme.colors.white}
                translucent={false}
            />
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        getUserRequest: state.api.getUser?.request,
        getUserSuccess: state.api.getUser?.success,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(mapStateToProps, mapDispatchToProps)(RankingScreen)
